/**
 * Colors for the document overlays that Find and citations draw. Search uses
 * butter yellow without a border, and citations use sea-glass teal, so the two
 * stay distinct when they cover the same paragraph. Fills are drawn with
 * `mix-blend-mode: multiply`, so they must stay light enough to keep text
 * readable.
 */
export const SEARCH_HIGHLIGHT_COLORS = {
  /** Fill of the selected matching paragraph. */
  selectedFill: '#FFF3B8',
  /** Soft glow around the selected paragraph, in place of an outline. */
  selectedGlow:
    '0 0 0 3px rgba(255, 230, 140, 0.6), 0 2px 10px 2px rgba(255, 220, 110, 0.35)',
  /** Fill of the other matching paragraphs. */
  matchFill: '#FFFAE0',
  /** Fill of every matched word, drawn over the paragraph fill. */
  wordFill: '#FFF0B0',
  /** Fill of the active citation. */
  citationFill: '#DFF3ED',
  /** Dashed border of citations. */
  citationBorder: '#59A995',
  /** Picker targets and the off-screen reference marker. */
  citationStrong: '#1F7C69',
} as const;
